<template lang="pug">
nav#navBar(ref="navBar")
    .bq-bar
        router-link.bq-bar-logo(to="/" data-track="navBar_logo" :class="{ 'bq-bar-logo--hide-mobile': isServicePage }")
            span.bq-logo-full(title="BunnyQuery") ₍ᐢ•⩊•ᐢ₎ {{route.name === "home" ? "" : "BunnyQuery" }}
            span.bq-logo-short(title="BunnyQuery") ₍ᐢ•⩊•ᐢ₎
        .bq-bar-service(v-if="isServicePage")
            span.material-symbols-outlined.bq-bar-service-back(@click="router.push({ name: 'my-projects' })" style="cursor:pointer;" title="Back to Project List") arrow_back_ios_new
            span.bq-bar-service-name(@click="router.push({ name: 'my-projects' })" style="cursor:pointer;" title="Back to Project List") {{ currentService?.service?.name }}
        .bq-bar-right
            .bq-desktop-nav
                button.bq-dark-toggle(@click="toggleDark" :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'" aria-label="Toggle dark mode")
                    span.material-symbols-outlined {{ isDark ? 'light_mode' : 'dark_mode' }}
                template(v-if="route.name === 'home'")
                    a.bq-bar-link(href="#how" @click.prevent="e=>scrollToSection(e)") How it works
                    a.bq-bar-link(href="#why" @click.prevent="e=>scrollToSection(e)") Why
                    a.bq-bar-link(href="#cases" @click.prevent="e=>scrollToSection(e)") Use cases
                template(v-if="user?.user_id")
                    //- router-link.bq-bar-link(to="/my-projects" data-track="navBar_my_baskets" v-if='route.path.startsWith("/my-projects/") || route.name === "home" || route.name === "account-settings"') [My Projects]
                    .bq-bar-project(v-if="isServicePage")
                        span.bq-bar-project-label Project:&nbsp;
                        router-link.bq-bar-project-name(:to="`/my-projects/${currentService.id}`") {{ currentService?.service?.name }}
                    .bq-bar-profile(@mouseenter="showProfileDropdown" @mouseleave="hideProfileDropdown")
                        span.bq-bar-avatar {{ userInitial }}
                        .bq-bar-dropdown(v-show="profileDropdownVisible")
                            .bq-bar-dropdown-email
                                span.user-id {{ userEmail }}
                                .bq-bar-dropdown-name {{ user?.name || "" }}
                            .bq-bar-dropdown-item(@click="()=>{navigateToMyProjects();clickProfileDropdown();}" data-track="navBar_myProjects") My Projects
                            .bq-bar-dropdown-item(@click="()=>{navigateToAccountPage();clickProfileDropdown();}" data-track="navBar_accountSet") Account Settings
                            //- .bq-bar-dropdown-item(@click="openBillingPage" data-track="navBar_billing") Billing
                            .bq-bar-dropdown-item(@click="()=>{logout();clickProfileDropdown();}" data-track="navBar_logout") Logout
                template(v-else)
                    router-link.bq-bar-link(to="/login" data-track="navBar_login") [Login]
                    router-link.btn(to="/signup" data-track="navBar_signup") Sign Up
            .bq-mobile-nav
                button.bq-dark-toggle(@click="toggleDark" :title="isDark ? 'Switch to light mode' : 'Switch to dark mode'" aria-label="Toggle dark mode")
                    span.material-symbols-outlined {{ isDark ? 'light_mode' : 'dark_mode' }}
                button.bq-bar-burger(@click="openMoMenu" aria-label="Menu") &#9776;
    .bq-mo-overlay(:class="{ open: moMenuOpen }")
        .bq-mo-header
            router-link.bq-bar-logo(to="/" @click="closeMobileMenu") BunnyQuery
            button.bq-mo-close(@click="closeMobileMenu" aria-label="Close") &times;
        .bq-mo-body
            //- template(v-if="route.name === 'home'")
            //-     a.bq-mo-link(href="#how" @click.prevent="e=>scrollToSection(e)") How it works
            //-     a.bq-mo-link(href="#why" @click.prevent="e=>scrollToSection(e)") Why
            //-     a.bq-mo-link(href="#cases" @click.prevent="e=>scrollToSection(e)") Use cases
                //- .bq-mo-divider
            template(v-if="user?.user_id")
                router-link.bq-mo-link(v-if="route.name === 'home' || route.name === 'my-projects'" to="/my-projects" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'my-projects' }") My Projects
                template(v-if="isServicePage")
                    //- .bq-mo-divider
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/agent`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'agent' }") AI Chat
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/dbfile`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'dbfile' }") Upload Files
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/users`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'users' }") Collaborators
                    //- router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/records`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'records' }") Database
                    router-link.bq-mo-link(:to="`/my-projects/${currentService.id}`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'dashboard' || route.name === 'records' }") Project Settings
                    //- router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/hosting`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'hosting' }") Hosting
                    //- router-link.bq-mo-link(:to="`/my-projects/${currentService.id}/clientsecret`" @click="closeMobileMenu" :class="{ 'bq-mo-link--active': route.name === 'clientsecret' }") API Keys
                //- br
                .bq-mo-link(@click="navigateToAccountPage" :class="{ 'bq-mo-link--active': route.path === '/account-settings' }") Account Settings
                .bq-mo-link(@click="logout") Logout
            template(v-else)
                //- .bq-mo-divider
                //- a.bq-mo-link(href="https://docs.skapi.com/introduction/getting-started.html" target="_blank" @click="closeMobileMenu") Docs
                router-link.bq-mo-link(to="/login" @click="closeMobileMenu") Login
                router-link.bq-mo-link(to="/signup" @click="closeMobileMenu") Sign Up
            br
            .bq-mo-footer
                a.bq-mo-footer-link(href="/tspp-bq.html" target="_blank" data-track="mobile_menu_terms") Terms of service / Privacy policy
                .bq-mo-footer-company {{ new Date().getFullYear() }} BROADWAYINC PTE. LTD. Singapore.
                .bq-mo-footer-email support&#64;broadwayinc&#46;com
                .bq-mo-footer-icons
                    a.bq-mo-footer-icon(href="http://www.tiktok.com/@skapi_api" target="_blank" data-track="mobile_menu_tiktok_icon")
                        img.bq-mo-footer-svg(:src="iconTiktok" alt="TikTok")
                    a.bq-mo-footer-icon(href="https://www.instagram.com/skapi_api" target="_blank" data-track="mobile_menu_instagram_icon")
                        img.bq-mo-footer-svg(:src="iconInstagram" alt="Instagram")
                    a.bq-mo-footer-icon(href="https://www.youtube.com/@skapi_official" target="_blank" data-track="mobile_menu_youtube_icon")
                        img.bq-mo-footer-svg(:src="iconYoutube" alt="YouTube")
                    a.bq-mo-footer-icon(href="https://x.com/skapi_api" target="_blank" data-track="mobile_menu_x_icon")
                        img.bq-mo-footer-svg(:src="iconX" alt="X")
                    a.bq-mo-footer-icon(href="https://www.linkedin.com/company/skapi-backend-api/" target="_blank" data-track="mobile_menu_linkedin_icon")
                        img.bq-mo-footer-svg(:src="iconLinkedin" alt="LinkedIn")
                    a.bq-mo-footer-icon(href="https://www.facebook.com/profile.php?id=61577236221327" target="_blank" data-track="mobile_menu_facebook_icon")
                        img.bq-mo-footer-svg(:src="iconFacebook" alt="Facebook")
                    a.bq-mo-footer-icon(href="https://dev.to/skapi_api" target="_blank" data-track="mobile_menu_devto_icon")
                        img.bq-mo-footer-svg(:src="iconDevto" alt="Dev.to")
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { computed, onMounted, ref } from "vue";
import { skapi } from "@/main";
import { user, customer } from "@/code/user";
import { currentService } from "@/views/project-list";
import { setAutoHide } from "./navBar-autohide.ts";
import {
    fullScreenLoader,
    removeFullScreenLoader,
} from "@/components/jsComponents";
import iconTiktok from "@/assets/img/landingpage/icon_tiktok.svg";
import iconInstagram from "@/assets/img/landingpage/icon_instagram.svg";
import iconYoutube from "@/assets/img/landingpage/icon_youtube.svg";
import iconX from "@/assets/img/landingpage/icon_x.svg";
import iconLinkedin from "@/assets/img/landingpage/icon_linkedin.svg";
import iconFacebook from "@/assets/img/landingpage/icon_facebook.svg";
import iconDevto from "@/assets/img/landingpage/icon_devto.svg";
const router = useRouter();
const route = useRoute();

let navBar = ref(null);
const userEmail = ref(user?.email || "");

const isServicePage = computed(() => {
    return !!currentService.value && ['dashboard', 'records', 'hosting', 'dbfile', 'clientsecret', 'agent', 'users'].includes(String(route.name));
});

const userInitial = computed(() => {
    const nameInitial = user?.name?.trim()?.charAt(0);
    if (nameInitial) {
        return nameInitial.toUpperCase();
    }
    return userEmail.value.charAt(0).toUpperCase();
});

const THEME_KEY = 'bq-theme';
const isDark = ref(false);

const initTheme = () => {
    const saved = localStorage.getItem(THEME_KEY);
    if (saved === 'dark') {
        isDark.value = true;
        document.documentElement.dataset.theme = 'dark';
    } else if (saved === 'light') {
        isDark.value = false;
        document.documentElement.dataset.theme = 'light';
    } else {
        isDark.value = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
};

const toggleDark = () => {
    isDark.value = !isDark.value;
    document.documentElement.dataset.theme = isDark.value ? 'dark' : 'light';
    try { localStorage.setItem(THEME_KEY, isDark.value ? 'dark' : 'light'); } catch {}
};

const profileDropdownVisible = ref(false);
let profileHideTimeout = null;
let profileClickClosedAt = 0;
const moMenuOpen = ref(false);

let openMoMenu = () => {
    moMenuOpen.value = !moMenuOpen.value;
    document.body.style.overflow = moMenuOpen.value ? "hidden" : "auto";
};

let openBillingPage = async () => {
    fullScreenLoader();
    let resolvedCustomer = await customer;

    skapi
        .clientSecretRequest({
            clientSecretName: "stripe_test",
            url: `https://api.stripe.com/v1/billing_portal/sessions`,
            method: "POST",
            headers: {
                Authorization: "Bearer $CLIENT_SECRET",
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: {
                customer: resolvedCustomer.id,
                return_url: window.location.origin + route.path,
            },
        })
        .then((response) => {
            window.location = response.url;
        });
};

let navigateToAccountPage = () => {
    closeMobileMenu();
    router.push({ path: "/account-settings" });
};
let navigateToMyProjects = () => {
    closeMobileMenu();
    router.push({ path: "/my-projects" });
};
let logout = () => {
    skapi.util.terminatePendingRequests();
    skapi.logout().then(() => {
        router.push({ path: "/" });
    });
    closeMobileMenu();
};

const closeMobileMenu = () => {
    moMenuOpen.value = false;
    document.body.style.overflow = "auto";
};

const scrollToSection = (e) => {
    const sectionId = e.target.getAttribute("href").substring(1);
    const section = document.getElementById(sectionId);
    if (section) {
        const remOffset =
            4 * parseFloat(getComputedStyle(document.documentElement).fontSize);
        const scrollY = section.offsetTop - remOffset;
        window.scrollTo({ top: scrollY, behavior: "smooth" });
    }

    closeMobileMenu();
};

// profile dropdown
const clickProfileDropdown = () => {
    if (profileHideTimeout) {
        clearTimeout(profileHideTimeout);
        profileHideTimeout = null;
    }
    if (profileDropdownVisible.value) {
        profileDropdownVisible.value = false;
        profileClickClosedAt = Date.now();
    } else {
        profileDropdownVisible.value = true;
    }
};

const showProfileDropdown = () => {
    if (Date.now() - profileClickClosedAt < 300) return;
    if (profileHideTimeout) {
        clearTimeout(profileHideTimeout);
        profileHideTimeout = null;
    }
    profileDropdownVisible.value = true;
};

const hideProfileDropdown = () => {
    // 약간의 지연을 두어 사용자가 popup으로 마우스를 이동할 시간을 제공
    profileHideTimeout = setTimeout(() => {
        profileDropdownVisible.value = false;
    }, 240);
};

onMounted(() => {
    initTheme();
    setAutoHide(navBar.value, 3);
});

</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

#navBar {
    position: var(--nav-position, fixed);
    top: var(--nav-top, 0px);
    left: 0;
    z-index: 99999999;
    width: 100%;
    height: 4rem;
    background: @paper;
    border-bottom: 1px solid @line;
    font-family: @mono;
    font-size: 0.875rem;
    color: @ink;
}

.bq-bar {
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
}

.bq-bar-logo {
    font-weight: 700;
    font-size: 1.1rem;
    letter-spacing: 0.04em;
    color: @ink;
    text-decoration: none;

    &:hover {
        text-decoration: none;
    }
}

.bq-logo-full {
    display: inline;
}

.bq-logo-short {
    display: none;
}

.bq-desktop-nav {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.bq-mobile-nav {
    display: none;
    align-items: center;
    gap: 1rem;
}

.bq-bar-right {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.bq-bar-link {
    color: @muted;
    text-decoration: none;
    font-size: 0.82rem;
    letter-spacing: 0.04em;
    transition: color 0.15s;

    &:hover {
        color: @ink;
        text-decoration: underline;
    }
}

/* ─── project name ─── */
.bq-bar-project {
    display: flex;
    align-items: center;
    font-size: 0.82rem;
    color: @muted;
    min-width: 0;
    max-width: 16rem;
}

.bq-bar-project-label {
    white-space: nowrap;
    flex-shrink: 0;
}

.bq-bar-project-name {
    color: @ink;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
        text-decoration: underline;
    }
}

/* ─── profile dropdown ─── */
.bq-bar-profile {
    position: relative;
    cursor: pointer;
}

.bq-bar-avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border: 1px solid @pink;
    background-color: @light-pink;
    color: @paper;
    font-size: 0.78rem;
    font-weight: 700;
    user-select: none;
}

.bq-bar-dropdown {
    position: absolute;
    // top: calc(100% + 0.5rem);
    // right: 0;
    min-width: 14rem;
    top: calc(100% - 0.25rem);
    right: 0.25rem;
    background: @paper;
    border: 1px solid @muted;
    padding: 0.2rem;
    z-index: 1000;
    font-size: 0.82rem;
    box-shadow: 2px 2px 0 rgba(0, 0, 0, 0.15);
}

.bq-bar-dropdown-email {
    padding: 0.75rem 1rem;
    margin-bottom: 0.2rem;
    border-bottom: 1px solid @line;
    color: @muted;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;

    .user-id {
        color: @ink;
    }

    .bq-bar-dropdown-name {
        display: block;
        margin-top: 0.35rem;
        font-size: 0.7rem;
        color: @muted;
        text-decoration: none;
        cursor: default;
    }
}

.bq-bar-dropdown-item {
    padding: 0.6rem 1rem;
    cursor: pointer;
    transition: background 0.1s;

    &:hover {
        background: @hover-bg;
    }
}

/* ─── dark mode toggle ─── */
.bq-dark-toggle {
    all: unset;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: @muted;
    transition: color 0.15s;

    .material-symbols-outlined {
        font-size: 1.25rem;
    }

    &:hover {
        color: @ink;
    }
}

/* ─── mobile burger ─── */
.bq-bar-burger {
    all: unset;
    cursor: pointer;
    font-size: 1.5rem;
    line-height: 1;
    color: @pink;
}

.bq-mo-overlay {
    position: fixed;
    top: 0;
    right: -100%;
    width: 100%;
    height: 100vh;
    background: @paper;
    z-index: 999999;
    transition: right 0.25s ease;
    display: flex;
    flex-direction: column;

    &.open {
        right: 0;
    }
}

.bq-mo-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 2rem;
    height: 4rem;
    border-bottom: 1px solid @line;
}

.bq-mo-close {
    all: unset;
    cursor: pointer;
    font-size: 1.75rem;
    line-height: 1;
    color: @muted;
}

.bq-mo-body {
    padding: 1rem 0;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.bq-mo-link {
    display: block;
    padding: 0.85rem 2rem;
    color: @ink;
    text-decoration: none;
    font-size: 0.95rem;
    cursor: pointer;

    &:hover {
        background: #f6f6f6;
        text-decoration: none;
    }

    &--active {
        color: @pink;
        font-weight: 600;
    }
}

.bq-mo-divider {
    height: 1px;
    background: @line;
    margin: 0.5rem 2rem;
}

.bq-mo-footer {
    // margin-top: 4rem;
    padding: 1.25rem 2rem 1.5rem;
    // border-top: 1px solid @line;
}

.bq-mo-footer-link {
    display: block;
    color: @muted;
    font-size: 0.8rem;
    text-decoration: none;

    &:hover {
        color: @ink;
        text-decoration: underline;
    }
}

.bq-mo-footer-company {
    margin-top: 0.3rem;
    font-size: 0.75rem;
    color: @muted;
}

.bq-mo-footer-email {
    margin-top: 0.8rem;
    font-size: 0.85rem;
    color: @muted;
}

.bq-mo-footer-icons {
    margin-top: 0.5rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
}

.bq-mo-footer-icon {
    display: inline-block;
}

.bq-mo-footer-svg {
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    object-fit: contain;
    filter: brightness(0) saturate(100%) invert(var(--bq-icon-invert));
    opacity: 0.82;
}

.bq-bar-service {
    display: none;
}

@media (max-width: 800px) {
    .bq-bar {
        padding: 0 1.25rem;
    }

    .bq-logo-full {
        display: none;
    }

    .bq-logo-short {
        display: inline;
    }

    .bq-desktop-nav {
        display: none;
    }

    .bq-mobile-nav {
        display: flex;
    }

    .bq-bar-logo--hide-mobile {
        display: none;
    }

    .bq-bar-service {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        min-width: 0;
        flex: 1;
        cursor: pointer;
    }

    .bq-bar-service-back {
        font-size: 1.1rem;
        color: @ink;
        flex-shrink: 0;
    }

    .bq-bar-service-name {
        font-family: @mono;
        font-size: 0.85rem;
        font-weight: 600;
        color: @ink;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        min-width: 0;
        margin-right: 1rem;
    }
}
</style>
